import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=15fd6d1f&scoped=true"
import script from "./PaymentSettings.vue?vue&type=script&lang=js"
export * from "./PaymentSettings.vue?vue&type=script&lang=js"
import style0 from "./PaymentSettings.vue?vue&type=style&index=0&id=15fd6d1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd6d1f",
  null
  
)

export default component.exports